export const BASE_URL = "https://backend.digitalmarketingcourseinbikaner.com";
